import { createSlice } from '@reduxjs/toolkit';
import { createReducerNames } from '../../../core/helpers/default';

const name = 'edit';

const reducersKeys = {
  editLabelRequest: 'editLabelRequest',
  editLabelSuccess: 'editLabelSuccess',
  editLabelFailure: 'editLabelFailure',
};

const initialState = {
  label: null,
  showModal: false,
  edited: false,
  loading: false,
  error: null,
};

const editLabel = createSlice({
  name,
  initialState,
  reducers: {
    [reducersKeys.editLabelRequest]: (state) => {
      state.loading = true;
    },
    [reducersKeys.editLabelSuccess]: (state) => {
      state.loading = false;
      state.showModal = false;
      state.edited = true;
    },
    [reducersKeys.editLabelFailure]: (state, { payload }) => {
      state.loading = false;
      state.error = payload.error;
    },
    openLabelModal: (state, { payload }) => {
      state.edited = false;
      state.label = payload.label;
      state.showModal = true;
    },
    closeLabelModal: (state) => {
      state.label = null;
      state.showModal = false;
    },
  },
});

export const labelEditReducer = createReducerNames(name, reducersKeys);
export const { actions } = editLabel;

export default editLabel.reducer;
